// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 23:06:45

export default {
  "id": "sweet-business-of-cats-cakes",
  "slug": "sweet-business-of-cats-cakes",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/8bbb246747684364a3c72b1c34c4767c-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/8bbb246747684364a3c72b1c34c4767c/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Sweet business of cats: cakes",
      "description": "An exciting game in which you have to interact with a variety of objects, manage cells and create delicious cakes based on original recipes.\n31 unique cakes!\n6 ingredients that can be combined!\nMore than a 13 000 customers!\n",
      "instructions": "Drag a coin to buy a random ingredient.\nDrag an ingredient to the cake cell to start baking.\nTap the oven to bake.\nFeed the cat by dragging food onto it—it'll eat, pay, and leave.\nTo refund a coin, drag the ingredient to the plate.\nIf an ingredient is in the cake box, double-click or use \"clear cells\" to refund.\nGiving the wrong cake may upset the customer.",
      "genres": [
        "Casual",
        "Simulation"
      ],
      "tags": [
        "2d",
        "cat",
        "chocolate",
        "cookie",
        "relax"
      ]
    },
    "zh-CN": {
      "title": "猫咪甜蜜的生意：蛋糕",
      "description": "一款激动人心的游戏，你需要与各种物体互动，管理细胞，并依据原创食谱制作美味的蛋糕。\n31款独特蛋糕！\n6种可组合的食材！\n超过13,000名顾客！",
      "instructions": "将硬币拖动购买随机食材。\n将食材拖动到蛋糕格中以开始烘焙。\n点击烤箱进行烘焙。\n通过将食物拖到猫身上来喂猫——它会吃、付钱并离开。\n要退还硬币，将食材拖动到盘子上。\n如果食材在蛋糕箱中，双击或使用“清空格子”来退还。\n送错蛋糕可能会惹恼顾客。",
      "genres": [
        "休闲",
        "模拟"
      ],
      "tags": [
        "2D",
        "猫",
        "巧克力",
        "饼干",
        "放松"
      ]
    },
    "zh-TW": {
      "title": "貓兒甜蜜的生意：蛋糕",
      "description": "一場刺激的遊戲，你必須與各種物品互動，管理細胞並根據獨特的食谱製作美味蛋糕。\n31種獨特蛋糕！\n6種可組合的食材！\n超過13,000位顧客！",
      "instructions": "將硬幣拖動以購買隨機食材。\n將食材拖動到蛋糕格中以開始烤蛋糕。\n點擊烤箱以烤蛋糕。\n將食物拖動到貓身上喂食——它會吃、付錢並離開。\n要退回硬幣，將食材拖動到盤子。\n如果食材在蛋糕盒中，雙擊或使用“清空格”功能以退回。\n給予錯誤的蛋糕可能會讓顧客不滿。",
      "genres": [
        "休闲",
        "模擬"
      ],
      "tags": [
        "2D",
        "貓",
        "巧克力",
        "餅乾",
        "放鬆"
      ]
    },
    "zh-HK": {
      "title": "貓貓甜蜜生意：蛋糕",
      "description": "一個刺激的遊戲，您需要與各種物品互動，管理細胞，並根據獨特配方製作美味蛋糕。\n31款獨特蛋糕！\n6種可組合的食材！\n超過13,000位顧客！",
      "instructions": "拉一個硬幣來購買隨機的食材。\n將食材拉到蛋糕格中開始烤蛋糕。\n按壓烤箱來烤蛋糕。\n將食物拖到貓身上來餵貓——它會吃、付款後離開。\n要退回硬幣，將食材拖到碟子上。\n如果食材在蛋糕盒中，雙擊或使用「清空格」來退回。\n送錯蛋糕可能會讓客人不高興。",
      "genres": [
        "隨意",
        "模擬"
      ],
      "tags": [
        "二維",
        "貓",
        "朱古力",
        "曲奇",
        "放鬆"
      ]
    },
    "ja": {
      "title": "猫の甘いビジネス：ケーキ",
      "description": "興味深いゲームで、様々なオブジェクトと対話し、細胞を管理し、オリジナルレシピに基づいて美味しいケーキを作成する必要があります。\n31種類のユニークなケーキ！\n組み合わせることができる6つの材料！\n13,000人以上の顧客！",
      "instructions": "コインを引っ張ってランダムな材料を購入。\n材料をケーキのセルに引っ張って焼き始める。\nオーブンをタップして焼く。\n食事を引っ張って猫に餌をやる－猫は食べ、支払いをし、去る。\nコインを返金するには、材料を皿に引っ張る。\n材料がケーキボックスにある場合、ダブルクリックまたは「セルをクリア」を使用して返金。\n間違ったケーキを渡すと顧客が不快になる。",
      "genres": [
        "カジュアル",
        "シミュレーション"
      ],
      "tags": [
        "2D",
        "猫",
        "チョコレート",
        "クッキー",
        "リラックス"
      ]
    },
    "ko": {
      "title": "고양이의 달콤한 사업: 케이크",
      "description": "흥미진진한 게임에서 다양한 물체와 상호작용하고 세포를 관리하여 독특한 레시피에 따라 맛있는 케이크를 만들어야 합니다.\n 31가지 독특한 케이크!\n 6가지 재료를 조합할 수 있습니다!\n 13,000명 이상의 고객!",
      "instructions": "코인을 드래그하여 무작위의 재료를 구매하세요.\n재료를 케이크 셀에 드래그하여 빚어 시작하세요.\n오븐을 탭하여 구워하세요.\n먹이를 드래그하여 고양이에게 먹이주세요—it'll eat, pay, and leave.\n코인을 환불하려면 재료를 접시에 드래그하세요.\n재료가 케이크 박스에 있을 때는 더블 클릭하거나 \"셀 지우기\"를 사용하여 환불하세요.\n잘못된 케이크를 주면 고객이 화가 나겠습니다.",
      "genres": [
        "캐주얼",
        "시뮬레이션"
      ],
      "tags": [
        "2D",
        "고양이",
        "쇼콜릿",
        "쿠키",
        "휴식"
      ]
    },
    "fr": {
      "title": "Affaires douces des chats : gâteaux",
      "description": "Un jeu passionnant où vous devez interagir avec une variété d'objets, gérer des cellules et créer de délicieux gâteaux selon des recettes originales.\n31 gâteaux uniques !\n6 ingrédients pouvant être combinés !\nPlus de 13 000 clients !",
      "instructions": "Faites glisser une pièce pour acheter un ingrédient aléatoire.\nFaites glisser un ingrédient dans la cellule du gâteau pour commencer à cuire.\nTapez sur le four pour cuire.\nAlimentez le chat en glissant de la nourriture dessus — il va manger, payer et partir.\nPour rembourser une pièce, glissez l'ingrédient sur la plate.\nSi un ingrédient est dans la boîte à gâteau, faites un double-clic ou utilisez \"vider les cellules\" pour rembourser.\nOffrir le mauvais gâteau peut énerver le client.",
      "genres": [
        "Casual",
        "Simulation"
      ],
      "tags": [
        "2D",
        "chat",
        "chocolat",
        "biscuits",
        "se détendre"
      ]
    }
  }
};
